





import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Collapse from '../collapse/collapse.vue';
import ChimeePlayer from 'chimee-player';

@Component({})
export default class Video extends Vue {
  player = null;
  classObject:any;
  ckey;
  @Prop({ default: null, type: String })
  item: any;

  @Prop({ default: null, type: Number })
  idx: any;

  @Watch('item')
  upDateitem(val: string) {
    setTimeout(() => this.initVideo(val));
  }

  @Watch('idx')
  upDateClass(val: number) {
    if (val == null) {
      return;
    }
    this.ckey = `chimee-container-${val}`;
    this.classObject = { [this.ckey]: true };
  }

  constructor() {
    super();
    this.classObject = { 'chimee-container': true };
    this.ckey = 'chimee-container';
    if(this.idx != null) {
      this.ckey = `chimee-container-${this.idx}`;
      this.classObject = { [this.ckey]: true };
      this.upDateitem(this.item);
    }
  }

  initVideo(path: string) {
    if (path != null && path.length > 0) {
      if (this.player == null) {
        this.player = new ChimeePlayer({
          wrapper: `.${this.ckey}`,
          src: path,
          isLive: false,
          box: 'native',
          autoplay: false,
          controls: true
        });
      } else {
        (this.player as any).load(path);
      }
    }
  }
  mounted() {}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/video/video.vue